import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgForOf, NgIf } from '@angular/common';
import { OrganisationService } from '../../../shared/services/organisation.service';
import { GlobalService } from '../../../shared/services/global.service';

import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'vex-add-org',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    MatCardModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    NgForOf,
    NgIf,
    MatButtonModule
  ],
  templateUrl: './add-org.component.html',
  styleUrl: './add-org.component.scss',
  providers: [GlobalService, OrganisationService]
})
export class AddOrgComponent implements OnInit {
  searchOrganizationForm: FormGroup = new FormGroup({});
  organization: any;
  submitted: any = false;
  orgButton: any = false;
  notfoundText: any = false;

  constructor(private formBuilder: FormBuilder,
              private OrganizationService: OrganisationService,
              private router: Router) {
  }

  ngOnInit() {
    this.searchOrganizationForm = this.formBuilder.group({
      organisation_name: ['', Validators.required]
    });
  }

  searchOrg() {
    this.submitted = true;
    if (this.submitted) {
      if (!this.searchOrganizationForm.valid) {
        return;
      }
      this.notfoundText = false;
      this.orgButton = true;
      let params = {
        'organisation_name': (this.searchOrganizationForm.value && this.searchOrganizationForm.value.organisation_name) ? this.searchOrganizationForm.value.organisation_name : ''
      };
      this.OrganizationService.search(params).subscribe(data => {
        if (data && data.id) {
          this.organization = data;
          this.orgButton = true;
        }
      }, error => {
        this.notfoundText = true;
        this.orgButton = false;
      });
    }


  }

  gotoUrl(data: any) {
    this.router.navigateByUrl(data);
  }

  gotoMain() {
    this.router.navigateByUrl('/auth/login');
  }

  protected readonly open = open;
}
